<div class="main">
    <div class="dx-field-title" translate>alerts.pageTitle</div>

    <dx-tab-panel #tabs style="height:calc(100vh - 200px);">
        <dxi-item [title]="'_commons.recipients' | translate" icon="email">
            <dx-data-grid #recipientsGrid
                          height="100%"
                          hoverStateEnabled="true"
                          id="tab-recipients"
                          keyExpr="id"
                          style="margin-top:5px;"
                          [columnAutoWidth]="true"
                          [dataSource]="recipients"
                          (onContextMenuPreparing)="onRecipientsContextMenuPreparing($event)">
                <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                <dxo-header-filter></dxo-header-filter>
                <dxo-scrolling showScrollbar="always"></dxo-scrolling>
                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-summary>
                    <dxi-total-item column="displayName" [displayFormat]="'alerts.lblAlertsCount' | translate" summaryType="count"></dxi-total-item>
                </dxo-summary>
                <dxo-toolbar>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="showRecipientCreatePopup()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="save" [text]="'alerts.lblSaveChanges' | translate" (onClick)="updateRecipients()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadData()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item name="searchPanel"></dxi-item>
                </dxo-toolbar>

                <dxi-column dataField="displayName" [caption]="'_commons.recipient' | translate" [calculateCellValue]="displayRecipientName"></dxi-column>
                <!-- Environment log types -->
                <dxi-column [caption]="'alerts.lblEnvironmentLogAlerts' | translate">
                    <dxi-column [width]="100" dataField="UnknownACKFileReceived" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblUnknownAckFileReceived' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="UnknownFileReceived" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblUnknownFileReceived' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="ConnectionFailed" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblConnectionFailed' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="AgentShutdownFailure" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblAgentShutdownFailure' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="AgentStartupFailure" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblAgentStartupFailure' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="CommandExpired" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblCommandExpired' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="ContactLostWithAgent" cellTemplate="enumCellEnvironmentLogTemplate"
                                [caption]="'alerts.lblContactLostWithAgent' | translate"></dxi-column>
                </dxi-column>
                <!-- File transfer log types -->
                <dxi-column [caption]="'alerts.lblFileTransfersLogAlerts' | translate">
                    <dxi-column [width]="100" dataField="TransferSucceeded" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblTransferSucceeded' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="TransferFailed" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblTransferFailed' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="ACKKOFileReceived" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblAckKoFileReceived' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="ACKOKFileReceived" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblAckOkFileReceived' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="NoACKReceived" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblNoAckReceived' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="FileAlreadyExistsInTarget" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblFileAlreadyExistsInTarget' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="ArchivedFileSentByEmail" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblArchivedFileSentByEmail' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="EmptyFileIgnored" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblEmptyFileIgnored' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="RealTimeDisconnected" cellTemplate="enumCellFileTransferLogTemplate"
                                [caption]="'alerts.lblRealTimeDisconnected' | translate"></dxi-column>
                </dxi-column>
                <!-- Remote platform log types -->
                <dxi-column [caption]="'alerts.lblRemotePlatformsLogAlerts' | translate">
                    <dxi-column [width]="100" dataField="CredentialsError" cellTemplate="enumCellRemotePlatformLogTemplate"
                                [caption]="'alerts.lblCredentialsError' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="TechnicalError" cellTemplate="enumCellRemotePlatformLogTemplate"
                                [caption]="'alerts.lblTechnicalError' | translate"></dxi-column>
                    <dxi-column [width]="100" dataField="InvalidCertificate" cellTemplate="enumCellRemotePlatformLogTemplate"
                                [caption]="'alerts.lblInvalidCertificate' | translate"></dxi-column>
                </dxi-column>

                <!-- Custom cell templates -->
                <div *dxTemplate="let cell of 'enumCellEnvironmentLogTemplate'">
                    <dx-check-box [value]="cell.data.environmentLogTypesEnums.indexOf(cell.column.dataField) > -1"
                                  (onValueChanged)="setRecipientEnvironmentLogValue(cell.data, cell.column.dataField, $event)">
                    </dx-check-box>
                </div>
                <div *dxTemplate="let cell of 'enumCellFileTransferLogTemplate'">
                    <dx-check-box [value]="cell.data.fileTransferLogTypesEnums.indexOf(cell.column.dataField) > -1"
                                  (onValueChanged)="setRecipientFileTransferLogValue(cell.data, cell.column.dataField, $event)">
                    </dx-check-box>
                </div>
                <div *dxTemplate="let cell of 'enumCellRemotePlatformLogTemplate'">
                    <dx-check-box [value]="cell.data.remotePlatformLogTypesEnums && cell.data.remotePlatformLogTypesEnums.indexOf(cell.column.dataField) > -1"
                                  (onValueChanged)="setRecipientRemotePlatformLogValue(cell.data, cell.column.dataField, $event)">
                    </dx-check-box>
                </div>
            </dx-data-grid>
        </dxi-item>
        <dxi-item [title]="'_commons.groups' | translate" icon="group">
            <dx-data-grid #groupsGrid
                          height="100%"
                          hoverStateEnabled="true"
                          keyExpr="id"
                          style="margin-top:5px;"
                          [columnAutoWidth]="true"
                          [dataSource]="groups"
                          [wordWrapEnabled]="true"
                          (onContextMenuPreparing)="onGroupsContextMenuPreparing($event)"
                          (onRowDblClick)="onGroupsRowDblClick($event)">
                <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                <dxo-header-filter></dxo-header-filter>
                <dxo-paging enabled="false"></dxo-paging>
                <dxo-summary>
                    <dxi-total-item column="name" [displayFormat]="'_commons.groupsCount' | translate" summaryType="count"></dxi-total-item>
                </dxo-summary>
                <dxo-toolbar>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="showGroupCreatePopup()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadData()"></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item name="searchPanel"></dxi-item>
                </dxo-toolbar>

                <dxi-column dataField="name" [caption]="'_commons.name' | translate"></dxi-column>
                <dxi-column dataField="recipients" [caption]="'_commons.recipients' | translate" [calculateCellValue]="concatRecipients"
                            cellTemplate="cellTemplateRecipients"></dxi-column>
                <div *dxTemplate="let cell of 'cellTemplateRecipients'">
                    <dx-tag-box [value]="cell.data.recipients" tagTemplate="recipientItem"
                                [readOnly]="true">
                        <div *dxTemplate="let recipient of 'recipientItem'">
                            <div class="dx-tag-content">{{recipient.emailAddress || recipient.user?.name}}</div>
                        </div>
                    </dx-tag-box>
                </div>
            </dx-data-grid>
        </dxi-item>
    </dx-tab-panel>
</div>

<!-- GROUP POPUPS -->
<dx-popup [title]="'alerts.lblGroupCreate' | translate" [(visible)]="createGroupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="createGroupVisible">
            <dx-validation-group #groupValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.name<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="newGroupData.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'alerts.valGroupNameRequired' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <hr /><br />
                <div class="dx-field">
                    <span class="dx-field-label" translate>_commons.employees<span class="dx-field-item-required-mark">
                            *</span></span>
                    <div class="dx-field-value">
                        <app-employee-picker [(selectedItems)]="newGroupData.users" [multiple]="true" [isRequired]="newGroupData.emails.length === 0"></app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <span class="dx-field-label" translate>_commons.emails<span class="dx-field-item-required-mark"> *</span></span>
                    <div class="dx-field-value">
                        <dx-tag-box (onInitialized)="hideTagBoxDropdown($event)" [(value)]="newGroupData.emails"
                            [acceptCustomValue]="true">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="newGroupData.users.length === 0" type="required"
                                    [message]="'alerts.required' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-tag-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createGroup()"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.createGroupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<dx-popup [title]="'alerts.lblGroupEdit' | translate" [(visible)]="editGroupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="editGroupVisible">
            <div class="dx-field">
                <div class="dx-field-label" translate>_commons.name</div>
                <div class="dx-field-value disabled-input">{{editGroupData.name}}</div>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>_commons.employees</span>
                <div class="dx-field-value">
                    <app-employee-picker [(selectedItems)]="editGroupData.users" [multiple]="true"></app-employee-picker>
                </div>
            </div>
            <div class="dx-field">
                <span class="dx-field-label" translate>_commons.emails</span>
                <div class="dx-field-value">
                    <dx-tag-box (onInitialized)="hideTagBoxDropdown($event)" [(value)]="editGroupData.emails"
                        [acceptCustomValue]="true"></dx-tag-box>
                </div>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="editGroup()"></dx-button>
                <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.editGroupVisible = false"></dx-button>
            </div>

        </dx-scroll-view>
    </div>
</dx-popup>

<!-- RECIPIENT POPUPS -->
<dx-popup [title]="'alerts.lblRecipientCreate' | translate" [(visible)]="createRecipientVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="createRecipientVisible">
            <dx-validation-group #recipientValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.email<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-text-box [readOnly]="newRecipientData.userId || newRecipientData.notificationGroupId"
                            [(value)]="newRecipientData.emailAddress">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                    type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.notificationGroupId"
                                    type="email" [message]="'alerts.valInvalidEmail' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.employee<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <app-employee-picker [readOnly]="newRecipientData.emailAddress || newRecipientData.notificationGroupId"
                            [isRequired]="!newRecipientData.emailAddress && !newRecipientData.notificationGroupId"
                            (selectedItemChange)="newRecipientData.userId = $event.id" (selectionCleared)="newRecipientData.userId = null">
                        </app-employee-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.group<span class="dx-field-item-required-mark"> *</span></div>
                    <div class="dx-field-value">
                        <dx-select-box [dataSource]="groups" displayExpr="name" [readOnly]="newRecipientData.emailAddress || newRecipientData.userId"
                            [showClearButton]="true" (onSelectionChanged)="newRecipientData.notificationGroupId = $event.selectedItem ? $event.selectedItem.id : null">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="!newRecipientData.userId && !newRecipientData.emailAddress"
                                    type="required" [message]="'alerts.required' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <hr /><br />
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblEnvironmentLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="environmentLogTypes" [displayExpr]="displayEnvironmentLogType" [showClearButton]="true" [showSelectionControls]="true"
                            [(selectedItems)]="newRecipientData.environmentLogTypesEnums" (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>alerts.lblFileTransfersLogAlerts</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="fileTransferLogTypes" [displayExpr]="displayFileTransferLogType" [showClearButton]="true"
                            [showSelectionControls]="true" [(selectedItems)]="newRecipientData.fileTransferLogTypesEnums"
                            (onInitialized)="showTagBoxDropButton($event)">
                        </dx-tag-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createRecipient()"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="createRecipientVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>
